import './license-attribution-modal.css';
